import request from '@/utils/request'

let Pick_cotton_imgApi = {

  /*采棉机图片列表*/
  list(data) {
    return request._post('/shop/plus.pick_cotton_img.Index/index', data);
},
/*添加采棉机图片*/
add(data) {
    return request._post('/shop/plus.pick_cotton_img.Index/add', data);
},
/*修改采棉机图片*/
edit(data) {
    return request._post('/shop/plus.pick_cotton_img.Index/edit', data);
},
/*删除采棉机图片*/
del(data) {
    return request._post('/shop/plus.pick_cotton_img.Index/del', data);
},
/*采棉机图片详情*/
detail(data) {
  return request._post('/shop/plus.pick_cotton_img.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.pick_cotton_img.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.pick_cotton_img.Setting/getSetting', data, errorback);
    },
}
export default Pick_cotton_imgApi;



// WEBPACK FOOTER //
// ./src/api/pick_cotton_img.js